import React from 'react';
import { formatInStoreTimezone } from '../../utils/dateUtils';
import useStoreTimezone from '../../hooks/useStoreTimezone';

const PurchaseHistory = ({ sales }) => {
  const fallbackTimezone = useStoreTimezone();
  return (
  <div>
    <h2 className="text-xl font-semibold mb-4">Purchase History</h2>
    <div className="overflow-x-auto bg-white rounded-lg shadow">
      <table className="min-w-full divide-y divide-gray-200">
        <thead className="bg-gray-50">
          <tr>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Receipt #</th>
            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Store</th>
            <th className="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Total</th>
          </tr>
        </thead>
        <tbody className="bg-white divide-y divide-gray-200">
          {sales.map(sale => {
            const timezone = sale.store?.timezone || fallbackTimezone;
            return (
            <tr key={sale._id}>
              <td className="px-6 py-4 whitespace-nowrap">
                {formatInStoreTimezone(sale.createdAt, 'dd-MM-yyyy hh:mm a', timezone)}
              </td>
              <td className="px-6 py-4 whitespace-nowrap font-mono">{sale.receiptNumber}</td>
              <td className="px-6 py-4 whitespace-nowrap">{sale.store.name}</td>
              <td className="px-6 py-4 whitespace-nowrap text-right font-semibold">${sale.finalAmount.toFixed(2)}</td>
            </tr>
          )})}
        </tbody>
      </table>
    </div>
  </div>
);
};

export default PurchaseHistory;
